var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader-wrapper"},[(_vm.isShow)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"text-center"},[_vm._t("default")],2),_c('div',{staticClass:"loader"})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }